<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }}
        FACTORY
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <vs-input
          label="Name"
          v-model="name"
          class="mt-5 w-full"
          name="name"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>

        <vs-input
          label="Initial"
          v-model="initial"
          class="mt-5 w-full"
          name="initial"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('initial')">{{
          errors.first("initial")
        }}</span>

        <vs-input
          label="Location"
          v-model="location"
          class="mt-5 w-full"
          name="location"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('location')">{{
          errors.first("location")
        }}</span>

        <div class="vx-row mt-5 ml-1">
          <vs-switch class="mr-4" v-model="active"></vs-switch>
          <span class="text-sm">Factory Status</span>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        let { _id, _rev, a, b, c, d, e, g } = JSON.parse(
          JSON.stringify(this.data)
        );
        this.id = _id;
        this.rev = _rev;
        this.name = a;
        this.initial = c;
        this.location = b;
        this.active = d;
        this.initValues();
      }
    },
  },
  data() {
    return {
      id: null,
      rev: null,
      name: "",
      initial: "",
      location: "",
      active: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return !this.errors.any() && this.name && this.initial && this.location;
    },
  },
  methods: {
    initValues() {
      if (this.data._id) return;
      this.id = null;
      this.name = "";
      this.initial = "";
      this.location = "";
      this.active = true;
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.notify({
            color: "warning",
            title: "Processing",
            text: "Processing Data",
          });
          const obj = {
            _id: this.id,
            _rev: this.rev,
            a: this.name.toUpperCase(),
            b: this.location.toUpperCase(),
            c: this.initial.toUpperCase(),
            d: this.active,
            e: Date.now(),
            y: Date.now(),
            z: 5,
          };

          if (this.id !== null && this.rev !== null) {
            this.$store
              .dispatch("factory/updateFactory", obj)
              .then((r) => {
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: r,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: err,
                });
              });
          } else {
            delete obj._id;
            delete obj._rev;
            this.$store
              .dispatch("factory/addFactory", obj)
              .then((r) => {
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: r,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: err,
                });
              });
          }
        }
      });
    },
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
